import { nf } from "@/lib/format";

export const ChartTooltip = ({ active, payload, label, unit = "" }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0];
  return (
    <div className="rounded-md border border-slate-700 bg-[#0a1425]/95 backdrop-blur px-3 py-2 text-xs shadow-xl">
      <p className="font-mono text-amber-400">{label ?? p.name}</p>
      {p.payload?.name && label && <p className="text-slate-400">{p.payload.name}</p>}
      <p className="mt-1 font-mono text-slate-100">
        {nf.format(p.value)} {unit}
      </p>
    </div>
  );
};
